const state = {
  amountOverdueData: [],
  satsangiGroups:[],
  chargeTypes: [],
  electricLines: [],
  paymentMethods: [],
  houseNoList: []
}

const getters = {}

const actions = {
  getAmountDueByPeriod ({ commit }) {
    axios
      .get("/electrical/reports/amountDueByPeriods")
      .then(response => (commit('setAmountDueByPeriod', response.data)));
  },
  getAmountDueByGroup ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reports/amountDueByGroups", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getPaymentsReceivedByDate ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reports/getPaymentsReceivedByDate", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getAmountDueBySelectionPeriod ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reports/amountDueBySelectionPeriod", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getReadingProfiles ({ commit }) {
    axios
      .get("/electrical/profiles")
      .then(response => (commit('setHouseNoList', response.data.data)));
  },
  getReadingByProfileMonth({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reading/getReadingByProfileMonth", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getReadings({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reading/getSelectedMonthReadings", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addReadings({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reading/createBulkReadingsByMonthYear", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editReadings({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reading/updateSingleReadingByMonthYear", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getElectricLineLoad ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/reports/lineLoadByYear", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getSatsangiGroups ({ commit }) {
    axios
      .get("/electrical/satsangiGroups")
      .then(response => (commit('setSatsangiGroups', response.data)));
  },
  updateProfile ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/profile/updateProfile", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addProfile({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/profile/addProfile", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getChargeTypes ({ commit }) {
    axios
      .get("/electrical/chargeTypes")
      .then(response => (commit('setChargeTypes', response.data.data)));
  },
  updateChargeType ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/chargeType/updateChargeType", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addChargeType ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/chargeType/addChargeType", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getElectricLines ({ commit }) {
    axios
      .get("/electrical/electricLines")
      .then(response => (commit('setElectricLines', response.data.data)));
  },
  updateElectricLine ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/electricLine/updateElectricLine", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addElectricLine ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/electricLine/addElectricLine", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  applyPayment ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/electrical/payment/applyPayment", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getPaymentMethods ({ commit }) {
    axios
      .get("/electrical/payment/getPaymentMethods")
      .then(response => (commit('setPaymentMethods', response.data.data)));
  },
}

const mutations = {
  setAmountDueByPeriod(state, data){
    state.amountOverdueData = data.data;
  },
  setSatsangiGroups (state, data) {
    state.satsangiGroups = data.data;
  },
  setChargeTypes (state, data) {
    state.chargeTypes = data.data;
  },
  setElectricLines (state, data) {
    state.electricLines = data.data;
  },
  setPaymentMethods(state, data) {
    state.paymentMethods = data.data;
  },
  setHouseNoList(state, data) {
    state.houseNoList = data;
  },


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
